exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-hover tbody tr.bg-primary:hover {\n    background-color: #007bff !important;\n    color: #ffffff !important;\n}\n", ""]);

// exports
